'use client'

import { useId as useReactId } from 'react'

export default function useId(idOverride?: string): string | undefined {
  const reactId = useReactId()
  return idOverride ?? reactId
}
